/**
 * Pagina lista motivazioni attività
 * @module Pages/Admin/Motivazioni/List
 */

import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { useCQuery } from '../../../../Services/QueryCache'
import { useNavigate } from 'react-router-dom'
import { Button, Flex, Modal, Spinner, Text } from '../../../../Components'
import { Column } from 'primereact/column'
import { deleteMotivazione, restoreMotivazione } from '../Functions'
import { columnProps } from '../../../../Services/Functions'
import { Checkbox } from 'primereact/checkbox'

export function MotivazioniList () {
  const [showDeleted, setShowDeleted] = useState(false)
  const { data: motivazioni = [], isSuccess } = useCQuery(['motivazioniAttivita', showDeleted ? 'true' : 'false'])
  const [motivazioniTable, setMotivazioniTable] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    isSuccess && setMotivazioniTable(motivazioni.map((r) => ({
      ...r,
      sottoProcessoDescrizione: r.sottoProcessiAttivitum?.descrizione || r.sottoProcessiAttivitum?.codice || 'Non assegnato',
      processoDescrizione: r.sottoProcessiAttivitum?.processiAttivitum?.descrizione || r.sottoProcessiAttivitum?.processiAttivitum?.codice || ''
    })))
  }, [motivazioni, isSuccess])

  const BtnActions = ({ id, deleted }) => {
    const [modalVisible, setModalVisible] = useState(false)
    return (
      <Flex width={160} row>
        <Modal visible={modalVisible} header='Disabilitazione Motivazione' onHide={() => setModalVisible(false)}>
          <Flex fw>
            <Text value='Vuoi disabilitare questa motivazione?' />
            <Flex fw row jb style={{ marginTop: 20 }}>
              <Button label='Annulla' icon='fa-duotone fa-times' onClick={() => setModalVisible(false)} />
              <Button label='Conferma' icon='fa-duotone fa-check' onClick={() => { deleteMotivazione(id); setModalVisible(false) }} />
            </Flex>
          </Flex>
        </Modal>
        <Button round tooltip='Modifica' icon='fa-duotone fa-pen' onClick={() => navigate('/admin/motivazioni/' + id)} />
        {deleted
          ? <Button style={{ marginLeft: 20 }} round tooltip='Riabilita' icon='fa-duotone fa-undo' onClick={() => restoreMotivazione(id)} />
          : <Button style={{ marginLeft: 20 }} round tooltip='Disabilita' icon='fa-duotone fa-ban' onClick={() => setModalVisible(true)} />}
      </Flex>
    )
  }

  if (!isSuccess) return <Spinner />
  return (
    <Flex fw fh js>
      <Flex fw row jb ae>
        <Text value='Lista Motivazioni' size={20} bold />
        <Flex row>
          <Flex row style={{ marginRight: 20 }}>
            <Text value='Mostra disabilitate' style={{ marginRight: 10 }} />
            <Checkbox checked={showDeleted} onChange={(e) => setShowDeleted(e.checked)} />
          </Flex>
          <Button label='Crea Nuova' icon='fa-duotone fa-plus' onClick={() => navigate('/admin/motivazioni/new')} />
        </Flex>
      </Flex>
      <DataTable
        style={{ width: '100%', marginTop: 20 }} filterDisplay='row' sortField='codice' sortOrder={1} className='TableSignatures'
        value={motivazioniTable} emptyMessage='Nessuna motivazione trovata' responsiveLayout='scroll' paginator rows={15}
      >
        <Column field='codice' {...columnProps('Codice')} />
        <Column field='label' {...columnProps('Label')} />
        <Column field='processoDescrizione' {...columnProps('Processo')} />
        <Column field='sottoProcessoDescrizione' {...columnProps('Sotto-Processo')} />
        <Column field='deleted' {...columnProps('Stato')} body={({ deleted }) => deleted ? 'Disabilitata' : 'Attiva'} />
        <Column style={{ border: 'none', width: 140, height: 15, textAlign: 'center' }} body={(props) => <BtnActions {...props} />} />
      </DataTable>
    </Flex>
  )
}
